import RUniq from 'ramda/src/uniq'
export default RUniq
